import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { UserCommunity } from '@/models/community.model';
import { User } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserCommunity',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  setup(__props) {


const store = useStore<ShiftCMSState & { us: UsersState }>();

const communities = computed<UserCommunity[]>(
  () => store.state.us.userCommunities,
);

function remove(id: number, userId: number) {
  store.dispatch(UsersActions.RemoveUserFromCommunity, { id, userId });
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (__props.user.id !== -1 && communities.value.length)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "mt-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(communities.value.length === 1 ? 'Community' : 'Communities'), 1)
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(communities.value, (uc) => {
            return (_openBlock(), _createBlock(_component_v_card_text, {
              key: uc.id
            }, {
              default: _withCtx(() => [
                _cache[1] || (_cache[1] = _createTextVNode(" User is a ")),
                (uc.isTemporary)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_1, "temporary "))
                  : _createCommentVNode("", true),
                _cache[2] || (_cache[2] = _createTextVNode("member of the ")),
                _createElementVNode("strong", null, _toDisplayString(uc.community.name), 1),
                _cache[3] || (_cache[3] = _createTextVNode(" Community ")),
                _createVNode(_component_v_btn, {
                  density: "compact",
                  onClick: () => remove(uc.community.id, __props.user.id),
                  color: "warning"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("Remove ")
                  ])),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})